<div class="modal-header">
  <p class="modal-title">{{ title() | translate }}</p>
  <i class="fa-light fa-xmark ms-auto cursor-pointer" (click)="dismiss()"></i>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="mb-3">
      <label for="reason" class="form-label">
        {{ 'shared.reasonDialog.fields.reason' | translate }}
      </label>
      <textarea
        id="reason"
        class="form-control"
        formControlName="reason"
        [class.is-invalid]="reasonControl.invalid && reasonControl.touched"
      ></textarea>
      @if (reasonControl.invalid && reasonControl.touched) {
        <div class="invalid-feedback">
          {{ 'shared.reasonDialog.errors.reasonRequired' | translate }}
        </div>
      }
    </div>
  </form>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-clear"
    [disabled]="closing"
    (click)="dismiss()"
  >
    {{ 'common.buttons.btnClose' | translate }}
  </button>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="form.invalid || closing"
    (click)="confirm()"
  >
    {{ 'common.buttons.btnConfirm' | translate }}
  </button>
</div>
